var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"delete",attrs:{"href":"javascript:void(0);"}},[_c('span',{staticClass:"action_icon"},[_c('img',{attrs:{"src":require("@/assets/images/group_del.svg"),"width":"22"}})]),_vm._v(" Delete ")])
}]

export { render, staticRenderFns }